
import React from 'react';
import './Academy.css';
import Header from '../../components/header/header';

const courseData = [
  {
    day: "Day 1",
    title: "Theory Class",
    points: [
      "Introduction to makeup artistry and its career scope",
      "Understanding face shapes and skin tones",
      "Basic color theory and its application in makeup",
      "Hygiene and sanitation practices for artists",
      "Product knowledge and makeup kit essentials"
    ]
  },
  {
    day: "Day 2 & 3",
    title: "Skin Prep and Base Mastery",
    points: [
      "Identifying skin types and choosing appropriate skincare products",
      "Prepping skin for a long-lasting base",
      "Foundation selection and shade matching",
      "Concealer and color correcting techniques",
      "Achieving a flawless, natural-looking base"
    ]
  },
  {
    day: "Day 4 & 5",
    title: "Eye Makeup Basics (Nude + Classy Smokey Eye)",
    points: [
      "Eye anatomy and understanding different eye shapes",
      "Tools and brushes for eye makeup application",
      "Creating a soft nude eye look for everyday wear",
      "Step-by-step guide for a classic smokey eye",
      "Blending techniques for seamless transitions"
    ]
  },
  {
    day: "Day 6",
    title: "Eyebrow Enhancing and Lip Shape",
    points: [
      "Eyebrow mapping and shaping based on face structure",
      "Filling and defining brows using different products (pencil, powder, gel)",
      "Correcting and enhancing natural lip shapes",
      "Lip liner application techniques for a fuller look",
      "Understanding different lipstick finishes"
    ]
  },
  {
    day: "Day 7",
    title: "Sharp Cut Crease",
    points: [
      "Introduction to the cut crease technique for bold eye looks",
      "Achieving sharp, defined creases using concealer and eyeshadow",
      "Blending dark and light shades for contrast",
      "Techniques for symmetrical eye makeup application"
    ]
  },
  {
    day: "Day 8",
    title: "Smooth Cut Crease",
    points: [
      "Creating a softer version of a cut crease",
      "Using gradient color transitions for a diffused look",
      "Tips for working with shimmers and glitter shadows",
      "Enhancing the eyes without harsh lines"
    ]
  },
  {
    day: "Day 9",
    title: "Halo Eye Makeup",
    points: [
      "Understanding the halo eye technique for a dimensional effect",
      "Applying dark and light shades to the center of the eyelid",
      "Blending for a spotlight effect"
    ]
  },
  {
    day: "Day 10",
    title: "Dark, Medium, Light Eye Makeup",
    points: [
      "Exploring the contrast of dark, medium, and light shades",
      "Techniques for achieving depth and definition",
      "Creating balanced and well-blended eye looks",
      "Suitable occasions and styles for this technique"
    ]
  },
  {
    day: "Day 11",
    title: "Arabian Eye Makeup",
    points: [
      "Introduction to the dramatic and bold Arabian eye look",
      "Using intense colors, thick liners, and heavy lashes",
      "Achieving an elongated and lifted appearance",
      "Enhancing the inner corners for a sultry effect"
    ]
  },
  {
    day: "Day 12",
    title: "Arabian Cut Crease",
    points: [
      "Advanced cut crease technique with vibrant colors",
      "Incorporating glitter, shimmer, and rhinestones for extra glam",
      "Precision liner application to enhance the eye shape",
      "Tips for symmetrical and sharp results"
    ]
  },
  {
    day: "Day 13 & 14",
    title: "Glossy Makeup Base",
    points: [
      "Achieving a dewy, glowing complexion",
      "Using cream and liquid products for a glass skin effect",
      "Highlighting techniques for natural radiance",
      "Product recommendations for long-lasting glow"
    ]
  },
  {
    day: "Day 15 & 16",
    title: "Waterproof Makeup",
    points: [
      "Understanding waterproof makeup products and their applications",
      "Techniques to ensure sweat-proof and tear-proof makeup",
      "Layering for maximum durability",
      "Setting spray and powder application for longevity"
    ]
  },
  {
    day: "Day 17 - 19",
    title: "Practice Days",
    points: [
      "Hands-on practice with guidance from the instructor",
      "Working on different skin tones and face shapes",
      "Troubleshooting common mistakes",
      "Creating signature looks using learned techniques",
      "Portfolio building and final assessment"
    ]
  },
  {
    day: "Day 20 - 25",
    title: "Basic Hair Styling",
    points: [
      "Hair Straightening",
      "Curling (inward and outward), crimping",
      "Braids, Bun, Front variation"
    ]
  },
  {
    day: "Day 26",
    title: "Client Consultation and Communication",
    points: [
      "Makeup vanity assembly",
      "Conducting a successful client consultation",
      "Understanding client preferences and offering suggestions",
      "Managing client expectations and handling feedback"
    ]
  },
  {
    day: "Day 27 - 29",
    title: "Portfolio and Certification",
    points: [
      "Portfolio preparation",
      "Final review and feedback",
      "Certification ceremony"
    ]
  }
];


const Academy = () => {
  return (
    <div className="NailArt-container">
      <Header />
       <h2>30 DAYS MASTER CLASS</h2>
      <p className="contact-info">
        +91 8279373678<br />
       <a href='https://www.instagram.com/priyapratapmakeup.studio/' target="_blank"
          rel="noopener noreferrer">priyapratapmakeup.studio</a><br />
        Certified by: Zorain's Studio, Bangalore
      </p>
      <p className="tagline">BASIC TO ADVANCE PROFESSIONAL MAKEUP COURSE</p>

      <button onClick={() =>
    window.open(
      'https://wa.me/918279373678?text=Hi, I am interested in joining the 30 Days Master Class. Please provide more details.',
      '_blank'
    )
  } className="book-now">BOOK NOW</button>

      <div className="post-grid">
        {courseData.map((course, index) => (
          <div key={index} className="post-card">
            {/* <img src={course.image} alt={course.title} /> */}
            <h3>{course.day}: {course.title}</h3>
            <ul>
              {course.points.map((point, i) => (
                <li key={i}>{point}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Academy;
